import React from "react";
import { LocaleProvider } from "./context/LocaleContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicePage from "./pages/ServicePage";
import PortfolioPage from "./pages/PortfolioPage";
import { Cursor } from "react-creative-cursor";
import "react-creative-cursor/dist/styles.css";
import ContactPage from "./pages/ContactPage";
import { FaMoon, FaSun } from "react-icons/fa";
import Header from "./components/Header";
// import Chatbot from "react-chatbot-kit";
// import config from "./chatbot/configs/chatbotConfig";
// import MessageParser from "./chatbot/MessageParser";
// import ActionProvider from "./chatbot/ActionProvider";
import "react-chatbot-kit/build/main.css";
// import { Fab } from "@mui/material";

function App() {
  const [locale, setLocale] = React.useState(
    localStorage.getItem("locale") != null
      ? localStorage.getItem("locale")
      : "id"
  );
  const [theme, setTheme] = React.useState(
    localStorage.getItem("theme") != null
      ? localStorage.getItem("theme")
      : "light"
  );

  document.documentElement.setAttribute("class", theme);
  const toggleLocale = () => {
    setLocale((prevLocale) => {
      const newLocale = prevLocale === "id" ? "en" : "id";
      localStorage.setItem("locale", newLocale);
      return newLocale;
    });
  };

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "dark" ? "light" : "dark";
      localStorage.setItem("theme", newTheme);
      document.documentElement.setAttribute("class", newTheme);
      return newTheme;
    });
  };

  const localeContextValue = React.useMemo(() => {
    return {
      locale,
      toggleLocale,
    };
  }, [locale]);

  const themeContextValue = React.useMemo(() => {
    return {
      theme,
      toggleTheme,
    };
  }, [theme]);

  // const fabStyle = {
  //   position: "fixed",
  //   bottom: 16,
  //   right: 16,
  // };

  // const [openChat, setOpenChat] = useState(false);

  return (
    <ThemeProvider value={themeContextValue}>
      <LocaleProvider value={localeContextValue}>
        {/* <Fab
          color="primary"
          size="medium"
          aria-label="add"
          sx={fabStyle}
          onClick={() => setOpenChat(!openChat)}>
          +
        </Fab>
        {openChat ? (
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        ) : (
          ""
        )} */}

        <Cursor
          isGelly={true}
          cursorSize="24px"
          cursorBackgrounColor={theme === "light" ? "#000000" : "#ffffff"}
        />
        <label className="theme-switcher-label" onClick={() => toggleTheme()}>
          {theme === "light" ? <FaMoon /> : <FaSun />}
        </label>
        <div className="tokyo_tm_all_wrap">
          <Header />
          <div className="rightpart">
            <div className="rightpart_in">
              <Routes>
                <Route path="/*" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/service" element={<ServicePage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route
                  path="/contact"
                  element={<ContactPage theme={theme} />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </LocaleProvider>
    </ThemeProvider>
  );
}

export default App;
